module.exports = __webpack_public_path__ + "static/media/customer-story-tulus-hero.7288f044.webp";